import { createSlice } from "@reduxjs/toolkit";
import { showToast } from "../../../components";

const initialState = {
  loading: false,
  error: null,
  kultFetch: { data: [] },
  hotlist: { data: [] },
  Candidates: { data: [], loading: false },
  AllCandidates: { data: [], loading: false },
  totalCandidates: 0,
  AlltotalCandidates: 0,
  onCandidate: { uiid: 0, addedBy: 0, fullData: null },
  parsedResume: { data: null, loading: false, error: null },
  uploads: { data: [] },
  assignedCandidates: 0,
  assignedCandidatesLoading: false,
  unAssignedCandidates: 0,
  unAssignedCandidatesLoading: false,
  users: { data: [], loading: false },
  usersCount: 0,
  usersCountLoading: false,
  contacts: { data: [] },
  submissionsData: { data: [] },
  interviewsData: { data: [] },
  placementData: { data: [] },
  candidateVersions: { data: [] },
  jobsCandidate: { data: [] },
  recruiterAssigned: { data: [] },
  recruitersUiid: { data: [] },
  globalCandidates: { data: [] },
  isDirty: false,
  openaiIntgrateAccess: { data: [] },
  apolloIntgrateAccess: { data: [] },
  interviewCount: { data: [], loading: false, error: null },
  placementCount: { data: [], loading: false, error: null },
  submissionCount: { data: [], loading: false, error: null },
  openaiOptimizationIntgrateAccess: { data: [] },
  candidateDraft: {
    basicInformation: null,
    preferences: null,
    passport: null,
    visa: null,
  },
  validEmailIntgrateAccess: null,
  onProject: { data: [] },
  onBench: { data: [] },
  onProjectAndBench: { data: [] },
  upcomingBench: { data: [] },
  dashboardCounts: {
    loading: false,
    totalCandidates: 0,
    onlyOnBenchCount: 0,
    onlyOnProjectCount: 0,
    bothCount: 0,
    upcomingBench: 0,
  },
  openaiDraftIntgrateAccess: { data: [] },
};

const nonitMarketingSlice = createSlice({
  name: "nonitMarketing",
  initialState,
  reducers: {
    // KULTFETCH
    fetchKultFetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchKultFetchSuccess(state, action) {
      state.loading = false;
      state.kultFetch.data = action.payload.data || [];
    },
    fetchKultFetchFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to fetch Kult Fetch data";
    },
    clearKultFetch(state) {
      state.kultFetch = { data: [] };
      state.loading = false;
      state.error = null;
    },
    // HOTLIST
    fetchHotlistStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchHotlistSuccess(state, action) {
      state.loading = false;
      state.hotlist.data = action.payload.data || [];
    },
    fetchHotlistFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to fetch Hotlist data";
    },
    clearHotlist(state) {
      state.hotlist = { data: [] };
      state.loading = false;
      state.error = null;
    },

    // ALL CANDIDATES
    fetchAllCandidatesStart(state) {
      state.AllCandidates.loading = true;
      state.error = null;
    },
    fetchAllCandidatesFailure(state, action) {
      state.AllCandidates.loading = false;
      state.error = action.payload || "failed to fetch candidate version";
    },
    fetchAllCandidatesSuccess(state, action) {
      state.AllCandidates.loading = false;
      state.AllCandidates = { data: action.payload.data || [] };
    },

    // CANDIDATES
    fetchCandidatesStart(state) {
      state.loading = true;
      state.Candidates.loading = true;
      state.error = null;
    },
    fetchCandidatesSuccess(state, action) {
      state.loading = false;
      state.Candidates.loading = false;
      state.Candidates = { data: action.payload.data || [] };
    },
    fetchCandidatesFailure(state, action) {
      state.loading = false;
      state.Candidates.loading = false;
      state.error = action.payload || "Failed to fetch candidates";
    },
    clearCandidates(state) {
      state.Candidates = { data: [] };
      state.loading = false;
      state.Candidates.loading = false;
      state.error = null;
    },
    deleteCandidateSuccess(state, action) {
      state.loading = false;
      state.Candidates.loading = false;
      const deletedCandidateUiid = action.payload.uiid;
      state.Candidates.data = state.Candidates.data.filter(
        (candidate) => candidate.uiid !== deletedCandidateUiid,
      );
    },

    fetchJobCandidateStart(state) {
      state.loading = true;
      state.error = null;
    },

    fetchJobCandidateSuccess(state, action) {
      state.loading = false;
      state.jobsCandidate = action.payload || [];
    },

    fetchJobCandidateFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to fetch Hotlist data";
    },
    fetchCandidateVersionStart(state, action) {
      state.loading = true;
      state.error = null;
    },
    fetchCandidateVersionFailure(state, action) {
      state.loading = false;
      state.error = action.payload = "failed to fetch candiate version";
    },
    fetchCandidateVersioSuccess(state, action) {
      state.loading = true;
      state.candidateVersions = { data: action.payload.data || [] };
    },

    // TOTAL COUNT
    fetchTotalCountStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchTotalCountSuccess(state, action) {
      state.loading = false;
      state.totalCandidates = action.payload.total || 0;
      state.totalSubmissions = action.payload.totalSubmissions || 0;
      state.totalInterviews = action.payload.totalInterviews || 0;
      state.totalPlacements = action.payload.totalPlacements || 0;
      state.assignedCandidates = action.payload.assignedCandidate || 0;
      state.unAssignedCandidates = action.payload.unassignedCandidate || 0;
      state.onlyOnProjectCount = action.payload.onlyOnProjectCount || 0;
      state.onlyOnBenchCount = action.payload.onlyOnBenchCount || 0;
      state.bothCount = action.payload.bothCount || 0;
    },
    fetchTotalCountFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to fetch total count";
    },

    addCandidateStart(state) {
      state.loading = true;
      state.error = null;
    },
    addCandidateSuccess(state, action) {
      state.loading = false;
      state.Candidates.data.push(action.payload);
    },
    addCandidateFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to add candidate";
    },

    setOnCandidate(state, action) {
      state.onCandidate = action.payload;
    },
    resetOnCandidate(state) {
      state.onCandidate = { uiid: 0, addedBy: 0, fullData: null };
    },
    setCandidateDraftSection(state, action) {
      const { section, data } = action.payload;
      state.candidateDraft[section] = data;
    },
    clearCandidateDraft(state) {
      state.candidateDraft = {
        basicInformation: null,
        preferences: null,
        passport: null,
        visa: null,
      };
    },

    // UPDATE CANDIDATE
    updateCandidateStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateCandidateSuccess(state, action) {
      state.loading = false;
      const updatedCandidate = action.payload;
      const index = state.Candidates.data.findIndex(
        (c) => c.uiid === updatedCandidate.uiid,
      );
      if (index !== -1) {
        state.Candidates.data[index] = updatedCandidate;
      }
    },
    updateCandidateFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to update candidate";
    },
    updatedMultipleCandidates(state, action) {
      const updatedList = action.payload;
      updatedList.forEach((updatedCandidate) => {
        const index = state.Candidates.data.findIndex(
          (c) => c.uiid === updatedCandidate.uiid,
        );
        if (index !== -1) {
          state.Candidates.data[index] = updatedCandidate;
        }
      });
    },

    // UPLOAD DOCUMENT
    uploadDocumentStart(state) {
      state.loading = true;
      state.error = null;
    },
    uploadDocumentSuccess(state, action) {
      state.loading = false;
      state.uploads.data = action.payload || [];
    },
    uploadDocumentFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to upload document";
    },
    clearUploads(state) {
      state.uploads = { data: [] };
      state.loading = false;
      state.error = null;
    },

    // USERS
    fetchUsersStart(state) {
      state.users.loading = true;
      state.error = null;
    },
    fetchUsersSuccess(state, action) {
      state.users.loading = false;
      state.users = { data: action.payload.data || [] };
    },
    fetchUsersFailure(state, action) {
      state.users.loading = false;
      state.error = action.payload || "Failed to fetch users";
    },
    clearUsers(state) {
      state.users = { data: [] };
      state.loading = false;
      state.error = null;
    },

    getTotalUserCountStart(state) {
      state.usersCountLoading = true;
      state.error = null;
    },
    getTotalUserCountSuccess(state, action) {
      state.usersCountLoading = false;
      state.usersCount = action.payload;
    },
    getTotalUserCountFailure(state, action) {
      state.usersCountLoading = false;
      state.error = action.payload || "Failed to fetch total count";
    },

    // CONTACTS
    addJobContactsStart(state) {
      state.loading = true;
      state.error = null;
    },
    addJobContactFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to Add Data ";
      showToast(
        " There is some error with job, Contact could not add..!",
        "error",
      );
    },
    addJobContactSuccess(state) {
      state.loading = false;
      showToast("Contact Added Succussfully", "success  ");
    },
    fetchCompanyContactStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCompanyContactFilure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to Add Data ";
    },
    fetchCompanyContactSuccess(state, action) {
      state.loading = false;
      state.contacts.data = action.payload || [];
    },
    updateContacts(state, action) {
      const { uiid, email, type = "Internal" } = action.payload;
      const index = state.contacts.data.data.findIndex(
        (item) => item.uiid === uiid && item.email === email,
      );
      if (index !== -1) {
        if (type === "Internal") {
          state.contacts.data.data[index].isInternallyVerified = true;
        } else if (type === "ValidEmail") {
          state.contacts.data.data[index].isValidEmailVerified = true;
        }
      }
    },

    // SUBMISSIONS
    addSubmissionStart(state) {
      state.loading = true;
      state.error = null;
    },
    addSubmissionSuccess(state) {
      state.loading = false;
    },
    addSubmissionFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to Add Data";
    },
    fetchSubmissionStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSubmissionSuccess(state, action) {
      state.loading = false;
      state.submissionsData.data = action.payload || [];
    },
    fetchSubmissionFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to Fetch Submission Data";
    },

    // INTERVIEWS
    addInterviewStart(state) {
      state.loading = true;
      state.error = null;
    },
    addInterviewSuccess(state) {
      state.loading = false;
    },
    addInterviewFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to add Interview Data";
    },
    fetchInterviewStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchInterviewFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Error while fetching data";
    },
    fetchInterviewSuccess(state, action) {
      state.loading = false;
      state.interviewsData.data = action.payload || [];
    },
    updatePlacementData(state, action) {
      const { interviewId, placementData } = action.payload;
      const index = state.interviewsData.data.findIndex(
        (item) => item.id === interviewId,
      );
      if (index !== -1) {
        state.interviewsData.data[index].placementData = placementData;
      }
    },

    // ANALYZE
    getCandidateAnalyzeStart(state) {
      state.loading = true;
      state.error = null;
    },
    getCandidateAnalyzeSuccess(state, action) {
      state.loading = false;
      state.selectedCandidateAnalyze = action.payload;
    },
    getCandidateAnalyzeFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // RECRUITER ASSIGNED
    getRecruiterAssignedStart(state) {
      state.loading = true;
      state.error = null;
    },
    getRecruiterAssignedSuccess(state, action) {
      state.loading = false;
      state.recruiterAssigned.data = action.payload || [];
    },
    getRecruiterAssignedFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // PARSE RESUME
    parseResumeStart(state) {
      state.parsedResume.loading = true;
      state.parsedResume.error = null;
    },
    parseResumeSuccess(state, action) {
      state.parsedResume.loading = false;
      state.parsedResume.data = action.payload;
    },
    parseResumeFailure(state, action) {
      state.parsedResume.loading = false;
      state.parsedResume.error = action.payload || "Failed to parse resume";
    },
    clearParsedResume(state) {
      state.parsedResume = { data: null, loading: false, error: null };
    },

    getRecruitersUiidStart(state) {
      state.loading = true;
      state.error = null;
    },
    getRecruitersUiidSuccess(state, action) {
      state.loading = false;
      state.recruitersUiid.data = action.payload || [];
    },
    getRecruitersUiidFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Falied to fetch Data";
    },

    ChangeIsDirty(state, action) {
      state.isDirty = action.payload;
    },

    getGlobalCandidateStart(state) {
      state.loading = true;
      state.error = null;
    },
    getGlobalCandidateSuccess(state, action) {
      state.loading = false;
      console.log(action.payload.total);
      state.globalCandidates = action.payload.total;
    },
    getGlobaleCandidateFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    openaiIntgrateAccessStart(state) {
      state.loading = true;
      state.error = null;
    },
    openaiIntgrateAccessSuccess(state, action) {
      state.loading = false;
      state.openaiIntgrateAccess.data = action.payload || [];
    },
    openaiIntgrateAccessFailure(state, action) {
      state.loading = false;
      state.error =
        action.payload || "Failed to fetch OpenAI integration access data";
    },

    getApolloIntgrateAccessStart(state) {
      state.loading = true;
      state.error = null;
    },
    getApolloIntgrateAccessSuccess(state, action) {
      state.loading = false;
      state.apolloIntgrateAccess.data = action.payload || [];
    },
    getApolloIntgrateAccessFailure(state, action) {
      state.loading = false;
      state.error =
        action.payload || "Failed to fetch Apollo integration access data";
    },

    openaiOptimizationIntgrateAccessStart(state) {
      state.loading = true;
      state.error = null;
    },
    openaiOptimizationIntgrateAccessSuccess(state, action) {
      state.loading = false;
      state.openaiOptimizationIntgrateAccess.data = action.payload || [];
    },
    openaiOptimizationIntgrateAccessFailure(state, action) {
      state.loading = false;
      state.error =
        action.payload ||
        "Failed to fetch OpenAI optimization integration access data";
    },

    openaiDraftIntgrateAccessStart(state) {
      state.loading = true;
      state.error = null;
    },
    openaiDraftIntgrateAccessSuccess(state, action) {
      console.log("PAYLOAD STRUCTURE:", JSON.stringify(action.payload));
      state.loading = false;
      state.openaiDraftIntgrateAccess.data = action.payload;
    },
    openaiDraftIntgrateAccessFailure(state, action) {
      state.loading = false;
      state.error =
        action.payload ||
        "Failed to fetch OpenAI draft integration access data";
    },

    getTotalInterviewCountStart(state) {
      state.interviewCount.loading = true;
      state.interviewCount.error = null;
    },
    getTotalInterviewCountSuccess(state, action) {
      state.interviewCount.loading = false;
      console.log(action.payload);
      state.interviewCount.data = action.payload;
    },
    getTotalInterviewCountFailure(state, action) {
      state.interviewCount.loading = false;
      state.interviewCount.error = action.payload;
    },

    getTotalPlacementCountStart(state) {
      state.interviewCount.loading = true;
      state.interviewCount.error = null;
    },
    getTotalPlacementCountSuccess(state, action) {
      state.interviewCount.loading = false;
      console.log(action.payload);
      state.interviewCount.data = action.payload;
    },
    getTotalPlacementCountFailure(state, action) {
      state.interviewCount.loading = false;
      state.interviewCount.error = action.payload;
    },

    getValidEmailIntgrateAccessStart(state) {
      state.loading = true;
      state.error = null;
    },
    getValidEmailIntgrateAccessSuccess(state, action) {
      state.loading = false;
      state.validEmailIntgrateAccess = action.payload;
    },
    getValidEmailIntgrateAccessFailure(state, action) {
      state.loading = false;
      state.error =
        action.payload || "Failed to fetch ValidEmail integration access data";
    },

    getAssignedCandidateStart(state) {
      state.assignedCandidatesLoading = true;
      state.error = null;
    },
    getAssignedCandidateSuccess(state, action) {
      state.assignedCandidatesLoading = false;
      state.assignedCandidates = action.payload;
    },
    getAssignedCandidateFailure(state, action) {
      state.assignedCandidatesLoading = false;
      state.error = action.payload || "Failed to fetch assignedCandidate data";
    },

    getUnAssignedCandidateStart(state) {
      state.unAssignedCandidatesLoading = true;
      state.error = null;
    },
    getUnAssignedCandidateSuccess(state, action) {
      state.unAssignedCandidatesLoading = false;
      state.unAssignedCandidates = action.payload;
    },
    getUnAssignedCandidateFailure(state, action) {
      state.unAssignedCandidatesLoading = false;
      state.error = action.payload || "Failed to fetch assignedCandidate data";
    },

    // DASHBOARD COUNTS
    getDashboardCountsStart(state) {
      state.dashboardCounts.loading = true;
      state.error = null;
    },
    getDashboardCountsSuccess(state, action) {
      state.dashboardCounts.loading = false;
      state.dashboardCounts.totalCandidates =
        action.payload.totalCandidates || 0;
      state.dashboardCounts.onlyOnBenchCount = action.payload.onBench || 0;
      state.dashboardCounts.onlyOnProjectCount = action.payload.onProject || 0;
      state.dashboardCounts.bothCount = action.payload.onProjectAndBench || 0;
      state.dashboardCounts.upcomingBench =
        action.payload.projectEndingInOneMonth || 0;
    },
    getDashboardCountsFailure(state, action) {
      state.dashboardCounts.loading = false;
      state.error = action.payload || "Failed to fetch dashboard counts data";
    },
  },
});

export const {
  getDashboardCountsStart,
  getDashboardCountsSuccess,
  getDashboardCountsFailure,
  getUnAssignedCandidateStart,
  getUnAssignedCandidateSuccess,
  getUnAssignedCandidateFailure,
  getAssignedCandidateStart,
  getAssignedCandidateFailure,
  getAssignedCandidateSuccess,
  setCandidateDraftSection,
  clearCandidateDraft,
  getTotalPlacementCountStart,
  getTotalPlacementCountFailure,
  getTotalPlacementCountSuccess,
  getTotalInterviewCountSuccess,
  getTotalInterviewCountStart,
  getTotalInterviewCountFailure,
  getGlobaleCandidateFailure,
  getGlobalCandidateStart,
  getGlobalCandidateSuccess,
  clearUsers,
  fetchKultFetchStart,
  fetchKultFetchSuccess,
  fetchKultFetchFailure,
  clearKultFetch,
  fetchHotlistStart,
  fetchHotlistSuccess,
  fetchHotlistFailure,
  clearHotlist,
  fetchCandidatesStart,
  fetchCandidatesSuccess,
  fetchCandidatesFailure,
  clearCandidates,
  fetchTotalCountStart,
  fetchTotalCountSuccess,
  fetchTotalCountFailure,
  addCandidateStart,
  addCandidateSuccess,
  addCandidateFailure,
  setOnCandidate,
  resetOnCandidate,
  updateCandidateStart,
  updateCandidateFailure,
  updateCandidateSuccess,
  uploadDocumentFailure,
  uploadDocumentSuccess,
  uploadDocumentStart,
  clearUploads,
  updatedMultipleCandidates,
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailure,
  getTotalUserCountStart,
  getTotalUserCountFailure,
  getTotalUserCountSuccess,
  addJobContactFailure,
  addJobContactSuccess,
  addJobContactsStart,
  updateContacts,
  fetchCompanyContactStart,
  fetchCompanyContactFilure,
  fetchCompanyContactSuccess,
  addSubmissionStart,
  addSubmissionFailure,
  addSubmissionSuccess,
  fetchSubmissionStart,
  fetchSubmissionFailure,
  fetchSubmissionSuccess,
  addInterviewFailure,
  addInterviewStart,
  addInterviewSuccess,
  fetchInterviewStart,
  fetchInterviewFailure,
  fetchInterviewSuccess,
  getCandidateAnalyzeStart,
  getCandidateAnalyzeSuccess,
  getCandidateAnalyzeFailure,
  fetchAllCandidatesStart,
  fetchAllCandidatesSuccess,
  fetchAllCandidatesFailure,
  updatePlacementData,
  fetchCandidateVersioSuccess,
  fetchCandidateVersionFailure,
  fetchCandidateVersionStart,
  fetchJobCandidateSuccess,
  fetchJobCandidateStart,
  fetchJobCandidateFailure,
  parseResumeStart,
  parseResumeSuccess,
  parseResumeFailure,
  clearParsedResume,
  getRecruiterAssignedStart,
  getRecruiterAssignedSuccess,
  getRecruiterAssignedFailure,
  getRecruitersUiidStart,
  getRecruitersUiidSuccess,
  getRecruitersUiidFailure,
  ChangeIsDirty,
  openaiIntgrateAccessStart,
  openaiIntgrateAccessSuccess,
  openaiIntgrateAccessFailure,
  getApolloIntgrateAccessStart,
  getApolloIntgrateAccessSuccess,
  getApolloIntgrateAccessFailure,
  openaiOptimizationIntgrateAccessStart,
  openaiOptimizationIntgrateAccessSuccess,
  openaiOptimizationIntgrateAccessFailure,
  openaiDraftIntgrateAccessFailure,
  openaiDraftIntgrateAccessSuccess,
  openaiDraftIntgrateAccessStart,
  getValidEmailIntgrateAccessStart,
  getValidEmailIntgrateAccessSuccess,
  getValidEmailIntgrateAccessFailure,
  deleteCandidateSuccess,
} = nonitMarketingSlice.actions;

export default nonitMarketingSlice.reducer;
